import { Col, Form, Modal, Row } from 'react-bootstrap'
import { useIntl } from 'react-intl'
import { InfoCard2 } from '../../../widgets/components/UI/InfoCard2'
import { Formik } from 'formik'
import { useState } from 'react'
import { toast } from 'react-toastify'
import { useAuth } from '../../../auth'
import { createRecipient } from '../../core/_requests'
import { useParams } from 'react-router-dom'
import Skeleton from 'react-loading-skeleton'
import TagInputDropdown from '../../../widgets/components/Input/TagInputDropdown'

const AddRecipientModal = ({
  isActive,
  setIsActive,
  getAllSecurityAndPermission,
  editSecurityData,
  setEditSecurityData,
  isLoading,
  emailList,
  getAllEmailList,
}: any) => {
  const { formatMessage } = useIntl()
  const { companyId } = useAuth()
  const { recordId } = useParams()
  const [loading, setLoading] = useState<boolean>(false)
  const [selctedOptionPayload, setSelectedOptionPayload] = useState<any[]>([])

  const initialValues = {}

  const handleSubmit = async (values: any, { resetForm }: any) => {
    try {
      if (!companyId || !recordId) return
      setLoading(true)
      const payload = {
        users: selctedOptionPayload,
      }

      const {
        data: { success, errors },
      } = await createRecipient(companyId, recordId, payload)
      if (success) {
        toast.success('New recipient added successfully')
        resetForm()
        setIsActive(false)
        getAllSecurityAndPermission()
        getAllEmailList()
      } else {
        toast.error(errors[0])
      }
    } catch (err) {
      console.log(err)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className='mt-4'>
      <Formik
        initialValues={initialValues}
        enableReinitialize={true}
        validateOnChange
        validateOnMount
        onSubmit={handleSubmit}
      >
        {(formik) => {
          return (
            <Form onSubmit={formik.handleSubmit}>
              <Modal
                show={isActive}
                onHide={() => {
                  setIsActive(false)
                  formik.resetForm()
                  setEditSecurityData(null)
                }}
                size='lg'
                fullscreen
              >
                <Modal.Header closeButton>
                  <h2>
                    {formatMessage({
                      id: editSecurityData
                        ? 'Edit Recipients to this file'
                        : 'Add Recipients to this file',
                    })}
                  </h2>
                </Modal.Header>
                <Modal.Body>
                  <div className='container'>
                    <div className='mt-4'>
                      <InfoCard2
                        title='Request a File Easily'
                        desc="Use this form to request specific files from team members or external contacts. Fill out the request details, including the urgency level, recipient's email, and a custom message. You can also send the request via WhatsApp for quicker responses."
                        slug='https://help.recordskeeper.ai/en/articles/10368140-how-to-request-a-file-seamlessly-on-recordskeeper-ai'
                      />
                    </div>
                    <Row>
                      {isLoading ? (
                        <div className='col-xl-12'>
                          <div className='row mt-md-8 mb-10 w-100 px-5 px-md-0 mb-4 justify-content-between'>
                            <div className='col-md-5 mb-10 mb-md-0'>
                              <div className='w-50'>
                                <Skeleton
                                  height={20}
                                  baseColor='var(--kt-skeleton-bg-color)'
                                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                />
                              </div>
                              <div className='mt-2'>
                                <Skeleton
                                  height={30}
                                  baseColor='var(--kt-skeleton-bg-color)'
                                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                />
                              </div>
                            </div>
                            <div className='col-md-5'>
                              <div className='w-50'>
                                <Skeleton
                                  height={20}
                                  baseColor='var(--kt-skeleton-bg-color)'
                                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                />
                              </div>
                              <div className='mt-2'>
                                <Skeleton
                                  height={30}
                                  baseColor='var(--kt-skeleton-bg-color)'
                                  highlightColor='var(--kt-skeleton-highlight-bg-color)'
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <>
                          <Col md={6}>
                            <TagInputDropdown
                              options={emailList}
                              tooltip='User can add users from here'
                              label='Select Users'
                              placeholder='Search'
                              onChange={(selectedOptions) => {
                                const selectedPayload = selectedOptions.map((option) => ({
                                  id: option.id,
                                  role: option.role,
                                }))

                                setSelectedOptionPayload(selectedPayload)
                              }}
                            />
                          </Col>
                        </>
                      )}
                    </Row>
                  </div>
                </Modal.Body>
                <Modal.Footer className='container px-0'>
                  <div className='d-md-flex w-100 justify-content-end px-md-0 px-0 gap-3 mt-4'>
                    <button
                      type='button'
                      className='btn bg-light custom-button-property text-muted w-auto'
                      onClick={() => {
                        setIsActive(false)
                        formik.resetForm()
                        setEditSecurityData(null)
                      }}
                    >
                      {formatMessage({ id: 'Cancel' })}
                    </button>
                    <button
                      type='submit'
                      className='btn bg-primary custom-button-property text-whtie w-auto'
                      disabled={selctedOptionPayload.length === 0 || loading}
                      onClick={formik.submitForm}
                    >
                      {!loading ? (
                        <span className='indicator-label font-size-13 p-0'>
                          {formatMessage({
                            id: 'Add User',
                          })}
                        </span>
                      ) : (
                        <span className='indicator-label font-size-13 p-0'>
                          {formatMessage({ id: 'Please wait...' })}
                          <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        </span>
                      )}
                    </button>
                  </div>
                </Modal.Footer>
              </Modal>
            </Form>
          )
        }}
      </Formik>
    </div>
  )
}

export default AddRecipientModal
